<template>
  <div class="substep-track-time">
    <div class="substep-header">
      <h3 data-testId="step-title">Track time to your projects</h3>
      <p>This timer is for demonstration only. Click play to see how tracking works.</p>
    </div>

    <div class="substep-content">
      <div id="gs-timer-container">
        <div id="gs-os-controls">
          <a href="#" />
          <a href="#" />
          <a href="#" />
        </div>
        <div id="gs-timer-inner">
          <div
            id="gs-timer"
            :class="{ 'running': timerRunning }"
          >
            {{ timerFormatted('full') }}
          </div>

          <div id="gs-timer-project-name">
            <h4>{{ projectName }}</h4>
          </div>

          <div id="gs-timer-controls">
            <a
              class="gs-timer-icon"
              :class="{ 'running': timerRunning }"
              @click="toggleTimer"
            >
              <i
                v-if="!timerRunning"
                class="hi hi-play"
              />
              <i
                v-else
                class="hi hi-stop"
              />
            </a>
          </div>

          <div id="gs-total-time">
            Today: <span>{{ timerFormatted('short') }}</span>
          </div>
        </div>

        <div id="gs-projects">
          <div
            v-for="project in projects"
            :key="project"
            class="gs-projects-item"
            :class="{ 'active': project === projectName }"
          >
            <a
              v-if="project !== projectName"
            />
            <a
              v-else
              class="gs-timer-icon"
              :class="{ 'running': timerRunning }"
              @click="toggleTimer"
            >
              <i
                v-if="!timerRunning"
                class="hi hi-play"
              />
              <i
                v-else
                class="hi hi-stop"
              />
            </a>
            <span>{{ project }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GettingStartedMixin from '~/mixins/GettingStarted/GettingStartedMixin';

export default {
  name: 'TrackTime',
  components: {
  },
  mixins: [GettingStartedMixin],
  props: {
    projects: {
      type: Array,
      required: true,
      validator: (value) => {
        return value.every(project => typeof project === 'string');
      }
    },
  },
  data: () => ({
    timerRunning: false,
    timer: 0,
  }),
  computed: {
    projectName() {
      return this.projects[0];
    },
  },
  mounted() {
    this.timerInterval = setInterval(() => {
      if (this.timerRunning) {
        this.timer += 1;
      }
    }, 1000);
  },
  beforeUnmount() {
    clearInterval(this.timerInterval);
  },
  methods: {
    timerFormatted(format) {
      const hours = Math.floor(this.timer / 3600);
      const minutes = Math.floor((this.timer % 3600) / 60);
      const seconds = this.timer % 60;
      let formatted = '';

      if (format === 'full') {
        formatted = [hours, minutes, seconds].map(v => (v.toString().padStart(2, '0'))).join(':');
      } else {
        formatted = `${hours.toString()}:${minutes.toString().padStart(2, '0')}`;
      }

      return formatted;
    },
    toggleTimer() {
      this.timerRunning = !this.timerRunning;
      this.$emit('completeSubstep');
    },
  },
};
</script>
